export default __webpack_public_path__ + "static/media/logo-with-legend.8eba854b.png";